import React, { useMemo, useState } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { CheckCircle } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';

const SmokeTest = () => {
  const [items, setItems] = useState([
    { id: 'tenant-roles', label: 'Crear tenant y asignar roles', done: false },
    { id: 'subscription', label: 'Cliente compra suscripcion via Stripe', done: false },
    { id: 'request', label: 'Cliente crea solicitud', done: false },
    { id: 'task-update', label: 'Operador ve tarea y actualiza estado', done: false },
    { id: 'client-updates', label: 'Cliente ve actualizaciones', done: false },
    { id: 'document', label: 'Subir documento y vincular a tarea', done: false },
    { id: 'jobs', label: 'Tareas programadas ejecutables', done: false },
  ]);
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return items;
    return items.filter((item) => item.label.toLowerCase().includes(normalized));
  }, [items, query]);

  const toggleItem = (id) => {
    setItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, done: !item.done } : item))
    );
  };

  const markAll = (done) => {
    setItems((prev) => prev.map((item) => ({ ...item, done })));
  };

  return (
    <div data-testid="smoke-test-page">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="text-4xl font-heading font-bold mb-2">Checklist de Smoke Test</h1>
          <p className="text-muted-foreground">Estandariza la validacion de releases</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => markAll(true)}>Marcar todo</Button>
          <Button variant="outline" onClick={() => markAll(false)}>Limpiar</Button>
        </div>
      </div>

      <Card className="mb-4">
        <CardContent className="p-4">
          <Input
            placeholder="Buscar en checklist"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="max-w-xs"
          />
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="space-y-4">
            {filtered.map((item) => (
              <div key={item.id} className="flex items-center justify-between gap-3 p-3 border rounded-lg">
                <div className="flex items-center gap-3">
                  <CheckCircle className={`w-5 h-5 ${item.done ? 'text-emerald-500' : 'text-slate-300'}`} />
                  <span className={item.done ? 'line-through text-muted-foreground' : ''}>{item.label}</span>
                </div>
                <input type="checkbox" checked={item.done} onChange={() => toggleItem(item.id)} />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
export default SmokeTest;
